import React, { useContext, useEffect, useRef, useState } from "react";
import "./InfoComponent.scss";
import { defined } from "cesium";
import LinkInfoComponent from "./LinkInfoComponent";
import ViewerContext from "../../context/ViewerContext";
import { getDegreeEntityPosition } from "../../helper/cesiumHelper";
import Draggable from "react-draggable";

let previousSelectedSatelliteId;
let previousSelectedStation;
function InfoComponent() {
  const [selectedItem, setSelectedItem] = useState();
  const [linkBudget, setLinkBudget] = useState(null);
  const [highlight, setHighlight] = useState(true);

  const { allData, linkChangeList } = useContext(ViewerContext);
  const linkListRef = useRef();
  const draggableRef = useRef(null);

  useEffect(() => {
    viewer.selectedEntityChanged.addEventListener(function (entity) {
      if (defined(entity)) {
        setSelectedItem(entity);
        const budget = getBudgetInformation(entity);
        setLinkBudget(budget);
      } else {
        setSelectedItem(null);
        setLinkBudget(null);
      }
    });
  }, []);

  useEffect(() => {
    linkListRef.current = allData;

    if (
      allData &&
      allData.hasOwnProperty("rx_stations") &&
      allData.hasOwnProperty("links") &&
      selectedItem
    ) {
      const budget = getBudgetInformation(selectedItem);
      setLinkBudget(budget);
    }
  }, [allData]);

  useEffect(() => {
    if (highlight) setHighlight(false);

    if (selectedItem && linkChangeList.length > 0) {
      let updateHighlight = false;
      console.log(linkChangeList);
      if (selectedItem.type == "link") {
        linkChangeList.forEach((item) => {
          const itemLinkId = `link-${item.stationName.trim()}`;
          if (itemLinkId == selectedItem.id) {
            updateHighlight = true;
          }
        });
      } else if (selectedItem.type == "station") {
        linkChangeList.forEach((item) => {
          if (item.stationName == selectedItem.name) {
            updateHighlight = true;
          }
        });
      } else {
        linkChangeList.forEach((item) => {
          if (
            item.oldSatId == selectedItem.id ||
            item.newSatId == selectedItem.id
          ) {
            updateHighlight = true;
          }
        });
      }

      setHighlight(updateHighlight);
    }
  }, [linkChangeList]);

  const setStationInfo = (linkItem, satelliteEntity) => {
    let infoObj = {};
    const stationList = linkListRef.current.rx_stations;

    const satellitePosition = getDegreeEntityPosition(viewer, satelliteEntity);
    const rxStation = stationList.find(
      (e) => e.name == linkItem.rx_station_name
    );

    infoObj = linkItem.link_budget;
    infoObj.celestrak_id = linkListRef.current.constellation.celestrak_id;
    infoObj.obs_time = linkListRef.current.obs_time;
    infoObj.station = rxStation;
    infoObj.satellite = satellitePosition;
    infoObj.satellite.id = linkItem.satellite_norad_id;
    infoObj.satellite.name = satelliteEntity.name;
    return infoObj;
  };

  const getBudgetInformation = (entity) => {
    const type = entity.type;
    const linkList = linkListRef.current.links;
    let satelliteDataSource = viewer.dataSources.getByName(
      "satellite-data-source"
    )[0];

    if (type == "link") {
      const linkId = entity.id;
      for (let i = 0; i < linkList.length; i++) {
        const linkItem = linkList[i];
        const itemLinkId = `link-${linkItem.rx_station_name.trim()}`;

        if (linkId == itemLinkId) {
          const satelliteEntity = satelliteDataSource.entities.getById(
            linkItem.satellite_norad_id
          );

          return setStationInfo(linkItem, satelliteEntity);
        }
      }
    } else if (type == "station") {
      const stationId = entity.id;
      for (let i = 0; i < linkList.length; i++) {
        const linkItem = linkList[i];
        const linkStationId = `station-${linkItem.rx_station_name.trim()}`;

        if (linkStationId == stationId) {
          if (linkItem.satellite_norad_id) {
            const satelliteEntity = satelliteDataSource.entities.getById(
              linkItem.satellite_norad_id
            );
            return setStationInfo(linkItem, satelliteEntity);
          }         
        }
      }
    } else {
      // viewer.selectedEntity.properties.getValue('type')
      const selectedEntityId = entity.id;

      //find if selected entity match with linked satellites
      const connectedLinks = linkList.filter(
        (e) => e.satellite_norad_id == selectedEntityId
      );

      //find the link that has highest cnr value
      let linkItem;
      connectedLinks.forEach((element) => {
        if (linkItem) {
          if (element.link_budget.cnr_dB > linkItem.link_budget.cnr_dB)
            linkItem = element;
        } else {
          linkItem = element;
        }
      });

      //If satellite already Connected a link show link info
      // else check if satellite is previously connected and changed, then select new satellite.
      if (linkItem) {
        const linkStationName = linkItem.rx_station_name;
        previousSelectedStation = linkStationName;
        previousSelectedSatelliteId = selectedEntityId;
        return setStationInfo(linkItem, entity);
      } else if (selectedEntityId == previousSelectedSatelliteId) {
        const matchedLinkData = linkList.find(
          (e) => e.rx_station_name == previousSelectedStation
        );
        if (matchedLinkData) {
          const satelliteEntity = satelliteDataSource.entities.getById(
            matchedLinkData.satellite_norad_id
          );
          if (satelliteEntity) {
            previousSelectedSatelliteId = null;
            viewer.selectedEntity = satelliteEntity;
            return getBudgetInformation(satelliteEntity);
          }
        }
      }
    }

    return null;
  };

  return (
    <>
      {linkBudget && (
        <Draggable
          nodeRef={draggableRef}
          position={null}
          grid={[10, 10]}
          scale={1}
          cancel=".settings-button"
        >
          <div
            ref={draggableRef}
            className={`infobox-container ${
              highlight ? "highlight" : ""
            } infobox-container-visible`}
          >
            <div className="infobox-container-title">
              {selectedItem.name ?? selectedItem._name}
            </div>
            <div className="infobox-container-content">
              <LinkInfoComponent entity={selectedItem} data={linkBudget} />
            </div>
          </div>
        </Draggable>
      )}
    </>
  );
}

export default InfoComponent;
